// Builds the pending-sync registration payload from the session's active
// project guid (stable) and the chat response's bridge_sync metadata.
// Returns null when we must NOT register (missing guid or command_id) so a
// sync is never staged under a guessed/ambiguous key.
export function buildPendingSyncPayload(activeProject, bridgeSync) {
  const projectGuid = (activeProject && activeProject.guid) ? String(activeProject.guid).trim() : "";
  const commandId = (bridgeSync && bridgeSync.command_id) ? String(bridgeSync.command_id).trim() : "";
  if (!projectGuid || !commandId) return null;
  const commandHash = (bridgeSync && bridgeSync.command_hash) ? String(bridgeSync.command_hash).trim() : "";
  return { project_guid: projectGuid, command_id: commandId, command_hash: commandHash };
}
